import {
  BASIC_LOT_DETAILS,
  PICKUP_ADDRESS,
  PICKUP_DETAILS,
  PICKUP_SCHEDULE_DETAILS,
  TITLE_DETAILS,
  SIGNATURE
} from "./constants";
import stepComponents from "./steps";
import stepFields from "./fieldStructure";
import locale from "../../utils/locale";

export default [
  {
    stepIndex: 0,
    stepName: BASIC_LOT_DETAILS,
    stepComponent: stepComponents[BASIC_LOT_DETAILS],
    stepFields: stepFields[BASIC_LOT_DETAILS],
    stepTitle: locale("personal_information"),
    stepIntroText: locale("confirm_information")
  },
  {
    stepIndex: 1,
    stepName: PICKUP_ADDRESS,
    stepComponent: stepComponents[PICKUP_ADDRESS],
    stepFields: stepFields[PICKUP_ADDRESS],
    stepTitle: locale("address"),
    stepIntroText: ""
  },
  {
    stepIndex: 2,
    stepName: TITLE_DETAILS,
    stepComponent: stepComponents[TITLE_DETAILS],
    stepFields: stepFields[TITLE_DETAILS],
    stepTitle: locale("title_information"),
    stepIntroText: locale("confirm_title_page")
  },
  {
    stepIndex: 3,
    stepName: PICKUP_DETAILS,
    stepComponent: stepComponents[PICKUP_DETAILS],
    stepFields: stepFields[PICKUP_DETAILS],
    stepTitle: locale("vehicle_information"),
    stepIntroText: locale("confirm_vehicle_ready")
  },
  {
    stepIndex: 4,
    stepName: SIGNATURE,
    stepComponent: stepComponents[SIGNATURE],
  }
];



// WEBPACK FOOTER //
// ./src/containers/PickupForm/stepsMap.js